export default __webpack_public_path__ + "static/media/Ivoryvale.35a96c64.jpg";